function hidePagination(sectionContainer) {
    const elementsToHide = sectionContainer.querySelectorAll(".glider-navigation");
    elementsToHide.forEach(element => element.style.display = "none");
}

function createSlider(colsInMobile, colsInDesktop, sectionId) {
    const carouselSelector = '.carousel-' + sectionId;
    new Glider(document.querySelector(carouselSelector), {
        slidesToShow: colsInMobile,
        slidesToScroll: colsInMobile,
        draggable: true,
        arrows: {
            prev: document.querySelector(carouselSelector).parentNode.querySelector('.glider-prev'),
            next: document.querySelector(carouselSelector).parentNode.querySelector('.glider-next')
        },
        responsive: [
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: colsInDesktop,
                    slidesToScroll: colsInDesktop,
                }
            }
        ]
    });
    const navigationItems = document.querySelector(carouselSelector).parentNode.querySelectorAll(".glider-navigation");
    navigationItems.forEach(element => element.style.display = "block");
}
